import { Wording } from '@/types';

export const YOGA_WORDING_FI: Wording = {
  components_header_media_content: 'Harjoitukset',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Reseptit',
  components_header_text2: 'Blogi',
  components_header_members: 'jäsenet',
  hero_text: 'Pidä kehosi joustavana ja vahvana',
  hero_button_text: 'Aloita joogamatkasi',
  components_ressources_section_title: 'RESURSSIT',
  components_ressources_subheader_text:
    'Kaikki tarvitsemasi resurssit harmoniseen elämäntapaan',
  components_ressources_span_text:
    'Avaa hyvinvoinnin salaisuudet: Sukella joogaasentojen, tietoisten meditaatioiden ja terveellisten reseptien kokoelmaan luodaksesi tasapainoa elämäsi kaikilla osa-alueilla.',
  components_ressources_card_1_title: 'Jooga vinkkejä',
  components_ressources_card_1_text:
    'Käytännön neuvoja harjoituksen syventämiseen ja asentojen parantamiseen.',
  components_ressources_card_2_title: 'Ruokavalio',
  components_ressources_card_2_text:
    'Älykkäitä ravitsemusvinkkejä terveempään ja vahvempaan.',
  components_ressources_link: 'Katso videoita',
  components_notes_and_google_title_1: 'Joogaharjoituksia',
  components_notes_and_google_title_2: 'Säännöllinen rutiini',
  components_notes_and_google_title_3: 'Ruokavalion ylläpito',
  components_review_google_text: 'Arvostele Googlessa',
  media_content_section_title: 'HARJOITUKSET',
  media_content_section_subheader_text: 'Meidän videot',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Lisää videoita',
  text2_section_title: 'BLOGI',
  text2_section_subheader_text: 'Artikkelit ja uutiset',
  text2_section_button_more: 'Lisää artikkeleita',
  components_text1_section_title: 'REseptejä',
  components_text1_subheader_text: 'Ravitse kehoasi ja mieltäsi',
  components_text1_span_text:
    'Terveellisiä reseptejä joogaharjoittelun tukemiseksi ja hyvinvoinnin parantamiseksi.',
  components_text1_card_1_title: 'Energisoivat aamiaiset',
  components_text1_card_1_text:
    'Herää eloisiin, energiaa lisääviin aterioihin.',
  components_text1_card_3_title: 'Tehokkaat lounaat',
  components_text1_card_3_text:
    'Löydä herkullisia ja käteviä lounasreseptejä, jotka on suunniteltu aktiiviseen elämäntapaasi. Värikkäistä salaateista proteiinipitoisiin kääreisiin nämä reseptit pitävät sinut virkeänä ja keskittyneenä.',
  components_text1_card_2_title: 'Illalliset palautumista varten',
  components_text1_card_2_text:
    'Tutki erilaisia ​​vähärasvaisia ​​proteiineja, täysjyvätuotteita ja eloisia vihanneksia saadaksesi päiväsi tyydyttävän päätöksen.',
  components_text1_link: 'Katso kaikki reseptit',
  components_footer_text: 'Löydä tasapaino, hengitä syvään: joogasi, matkasi.',
  components_footer_info: 'Tiedot',
  components_footer_registration_number: 'Rekisterinumero',
  components_footer_legal: 'Laillinen',
  components_footer_terms: 'Ehdot',
  components_footer_privacy: 'Tietosuojakäytäntö',
  button_load_more: 'Lataa lisää',
  page_media_1_content_hero_text: 'Joogaharjoituksia',
  page_text1_hero_text: 'Reseptit',
  page_text1_section_title: 'Ravitsemus',
  page_text1_subheader_text: 'Reseptit',
  page_text2_hero_text: 'Meidän blogi',
  page_text2_section_title: 'Blogi',
  page_text2_subheader_text: 'Artikkelit ja uutiset',
  enter_email_title: 'Anna sähköpostiosoitteesi jatkaaksesi',
  enter_email_placeholder_email: 'Sähköposti',
  enter_email_button_enter: 'Enter',
  components_login_success_text: 'Kirjautuminen onnistui!',
  components_card_link_media_content: 'Katso nyt',
  components_card_link_text1_content: 'Katso Resepti',
  components_card_link_text2_content: 'Katso artikkeli',
  france: 'Ranska',
  cyprus: 'Kypros',
};
